/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useRef } from 'react';
import { FixedSizeList as List } from 'react-window';
import { ILegacySelectItem, ISelectOption } from './Select';

const getFocusIndex = (children: any[]): number => children.findIndex(child => child.props.isFocused);

interface IProps<T> {
  options?: Array<ILegacySelectItem<T>> | Array<ISelectOption<T>>;
  children?: any;
  maxHeight?: number;
  getValue?: () => any;
}

export const SelectMenuList: FC<IProps<string>> = ({ children, getValue, maxHeight, options }) => {
  const listRef = useRef(null);
  const itemSize = 32;
  const [selectedValue] = getValue();
  let height = maxHeight;

  useEffect(() => {
    if (children.length) {
      const currentIndex = getFocusIndex(children);

      if (currentIndex >= 0) {
        listRef.current.scrollToItem(currentIndex);
      }
    }
  }, [children]);

  if (!children.length) {
    // This returns the 'No results' message
    return children;
  } else if (height > children.length * itemSize) {
    height = children.length * itemSize;
  }

  const initialOffset = selectedValue ? options.indexOf(selectedValue) * itemSize : 0;

  return (
    <List
      height={height}
      itemCount={children.length}
      itemSize={itemSize}
      initialScrollOffset={initialOffset}
      ref={listRef}
      width="100%"
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

export default SelectMenuList;
